export default "__VITE_ASSET__C$bXBcM2__"